export default __webpack_public_path__ + "static/media/prize-4-bm.0f7d2043.webp";